import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../App';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

function CustomerSOP({ user }) {
  const navigate = useNavigate();
  const [sop, setSop] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSOP();
  }, []);

  const fetchSOP = async () => {
    try {
      const response = await axios.get(`${API}/customer-sop`);
      setSop(response.data);
    } catch (error) {
      toast.error('Failed to fetch SOP');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-white to-primary/5">
      <header className="glass border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate('/')}
            data-testid="back-button"
            className="rounded-xl"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div className="flex-1">
            <h1 className="font-bold text-lg text-gray-900">Customer Interaction SOP</h1>
            <p className="text-xs text-gray-500">Customer service workflow</p>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-6">
        <div className="bg-white rounded-2xl p-6 shadow-md">
          <div 
            className="prose prose-sm max-w-none customer-sop-content"
            dangerouslySetInnerHTML={{ __html: sop?.content || '<p>No content available</p>' }}
          />
        </div>
      </main>

      <style>{`
        .customer-sop-content h2 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #6B00A3;
          margin-bottom: 1.5rem;
        }
        .customer-sop-content .step {
          margin-bottom: 2rem;
          padding: 1.5rem;
          background: linear-gradient(to right, #f9fafb, #ffffff);
          border-left: 4px solid #6B00A3;
          border-radius: 0.75rem;
        }
        .customer-sop-content .step h3 {
          font-size: 1.125rem;
          font-weight: 600;
          color: #111827;
          margin-bottom: 0.75rem;
        }
        .customer-sop-content ul {
          list-style-type: disc;
          padding-left: 1.5rem;
          margin: 0.5rem 0;
        }
        .customer-sop-content li {
          margin: 0.5rem 0;
          color: #374151;
        }
        .customer-sop-content strong {
          color: #6B00A3;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
}

export default CustomerSOP;